import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, MapPin, CalendarDays, Shield, CreditCard } from 'lucide-react';

const SERVICES = [
  {
    icon: Users,
    label: 'Especialistas',
    description: 'Busca entrenadores, nutricionistas y doctores',
    path: '/client/services/specialists',
    color: '#6366F1',
    gradient: 'from-indigo-500 to-violet-500',
  },
  {
    icon: CreditCard,
    label: 'Suscripciones',
    description: 'Gestiona tus planes y membresías',
    path: '/client/services/subscriptions',
    color: '#10B981',
    gradient: 'from-emerald-500 to-teal-500',
  },
  {
    icon: MapPin,
    label: 'Especialistas Cercanos',
    description: 'Encuentra profesionales cerca de ti',
    path: '/client/services/nearby',
    color: '#EF4444',
    gradient: 'from-red-500 to-rose-500',
  },
  {
    icon: CalendarDays,
    label: 'Eventos',
    description: 'Talleres, charlas y actividades de bienestar',
    path: '/client/services/events',
    color: '#F59E0B',
    gradient: 'from-amber-500 to-orange-500',
  },
  {
    icon: Shield,
    label: 'Grupos Deportivos',
    description: 'Unete a comunidades y entrena en grupo',
    path: '/client/services/groups',
    color: '#0EA5E9',
    gradient: 'from-sky-500 to-blue-500',
  },
];

const ClientServicesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto space-y-5 animate-fade-in pb-4" data-testid="client-services-page">
      <div className="pt-1">
        <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          Servicios
        </h1>
        <p className="text-sm text-gray-400 mt-1 font-medium">Explora nuestros servicios de salud y bienestar</p>
      </div>

      <div className="space-y-3">
        {SERVICES.map((service, idx) => {
          const IconComp = service.icon;
          return (
            <button
              key={service.path}
              onClick={() => navigate(service.path)}
              className="w-full bg-white rounded-2xl border border-gray-100/50 p-4 text-left shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group"
              style={{ animationDelay: `${idx * 60}ms` }}
              data-testid={`service-card-${service.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="flex items-center gap-4">
                <div
                  className={`w-13 h-13 rounded-2xl bg-gradient-to-br ${service.gradient} flex items-center justify-center shadow-lg flex-shrink-0 group-hover:scale-105 transition-transform duration-300`}
                  style={{ width: '52px', height: '52px', boxShadow: `0 4px 14px ${service.color}30` }}
                >
                  <IconComp size={24} className="text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-gray-900 text-sm" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                    {service.label}
                  </p>
                  <p className="text-xs text-gray-400 mt-0.5">{service.description}</p>
                </div>
                <div className="text-gray-300 group-hover:text-gray-500 transition-colors">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ClientServicesPage;
